

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';


export interface AdmissionAccidentMasterParameter extends Parameter {
  searchTerm: number;
  orderBy: string;

}


export interface AdmissionAccidentMaster {

id?: any;

accidentTypeId:string;
arNumber:string;
policeStation:string;
mLCNUmber:string;
accidentDate:string;
accidentTime:string;
broughtBy:string;
informant:string;
firstAid:string;
accidentLocation:string;
modeOfArrival:string;
thirdPartyResponsibility:string;
briefHistory:string;
investigatingOfficer:string;
clinicalFindings:string;
notes:string;
//alcoholAbuse:string;
admissionId:string;
parameters?: AdmissionAccidentMasterParameter[];
links?: any;
tenantId:string;
branchId:string;
approvalDet?: any;
approvalId?: any
}


export abstract class AdmissionAccidentMasterData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<AdmissionAccidentMaster[]>;
  abstract create(url: string, data: AdmissionAccidentMaster): Observable<AdmissionAccidentMaster>;
  abstract update(url: string, data: AdmissionAccidentMaster): Observable<AdmissionAccidentMaster>;
  abstract delete(url: string): Observable<any>;


}
